import { render, staticRenderFns } from "./GenerateInvoiceForm.vue?vue&type=template&id=720f72be&"
import script from "./GenerateInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./GenerateInvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports